<template>
    <div>
        <checkout namespace="reports" />
    </div>
</template>
